import React from 'react';
import clsx from 'clsx';

export interface CardProps {
  variant?: 'default' | 'elevated' | 'interactive';
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

const variantClasses = {
  default: 'bg-white border border-border shadow-sm',
  elevated: 'bg-white shadow-lg',
  interactive:
    'bg-white border border-border hover:shadow-md hover:border-primary/30 transition-all duration-200 cursor-pointer',
};

export const Card: React.FC<CardProps> = ({
  variant = 'default',
  className,
  style,
  children,
}) => {
  return (
    <div className={clsx('rounded-xl', variantClasses[variant], className)} style={style}>
      <div className="p-6">{children}</div>
    </div>
  );
};

export default Card;